type OktaConfig = {
  clientID: string;
  issuer: string;
  postLogoutRedirectUri: string;
  redirectUri: string;
};

export const OKTA_CONFIG: OktaConfig = {
  clientID: window.__app_config.WEBUI_OKTA_CLIENT_ID,
  issuer: window.__app_config.WEBUI_OKTA_SERVICE_URL + window.__app_config.WEBUI_OKTA_ISSUER,
  redirectUri: `${window.__app_config.WEBUI_ROUTING_BASE_PATH}/implicit/callback`,
  postLogoutRedirectUri: window.__app_config.WEBUI_ROUTING_BASE_PATH,
};
